module.exports = __webpack_public_path__ + "img/points.1ba89831.png";